import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 360px;
  background: rgba(108, 109, 106, 0.2);
  backdrop-filter: blur(14px);

  right: 0;
  z-index: 1;
  position: absolute;
  user-select: none;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .buttons-container {
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      width: 100%;
    }
  }

  .current-month-container {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 24px;
      height: 24px;
    }
  }

  .weekdays-container {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .weekday {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ${({ theme }) => css`
    gap: ${theme.padding.small};
    padding: ${theme.padding.small};
    top: calc(${theme.padding.small} + 48px);
    border-radius: ${theme.borderRadius.big};

    .buttons-container {
      gap: ${theme.padding.small};
      margin-top: ${theme.padding.default};
    }

    .current-month-container {
      gap: ${theme.padding.smallest};
    }

    .weekdays-container .weekday {
      color: ${theme.colors.lightGrey.main};
    }
  `}
`;
